'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useAtomValue } from 'jotai';
import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import ListingsSeoLinks from '@/features/listing/components/listings-section/listings-seo-links/listings-seo-links';
import { type ListingType } from '@/features/listing/types/listing-types';
import { type SeoText } from '@/features/listing/types/seo-text-types';
import { type GeoPage } from '@/features/place/types/geo-page-types';
import styles from './listings-seo.module.scss';
interface ListingsSeoProps {
  listingType: ListingType;
  geoPage?: GeoPage | null;
  seoText: SeoText | null;
  location: string;
}
export default function ListingsSeo(props) {
  const $ = _c(12);
  const {
    geoPage,
    listingType,
    seoText,
    location
  } = props;
  const isMapView = useAtomValue(isMapViewAtom);
  const t0 = isMapView && styles.listingsSeo__isMapView;
  let t1;
  if ($[0] !== t0) {
    t1 = cx(styles.listingsSeo, t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== seoText) {
    t2 = seoText && <div><h2 className={styles.listingsSeo_title}>{seoText.title}</h2><br /><div className={styles.listingsSeo_description} dangerouslySetInnerHTML={{
        __html: seoText.description
      }} /></div>;
    $[2] = seoText;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== geoPage || $[5] !== listingType || $[6] !== location) {
    t3 = geoPage && (geoPage.cityLinks || geoPage.neighborhoodLinks) && <ListingsSeoLinks listingType={listingType} geoPage={geoPage} location={location} />;
    $[4] = geoPage;
    $[5] = listingType;
    $[6] = location;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}